export enum PaymentTransactionStatusEnum {
  "PENDING" = "PENDING",
  "SUCCESS" = "SUCCESS",
  "FAILED" = "FAILED",
}
